import $ from "jquery";
import 'slick-carousel';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';

// Dropdown nav menu
$('.menu-item-has-children').on('click', function () {
    $('.menu-item-has-children').toggleClass('dropdown-show');
});
// Hamburger menu
$('.navbar-toggler').on('click', function () {
    $('.navbar-toggler').toggleClass('is-toggled');
    $('.navbar').toggleClass('show');
});

// Masonry ERROR
// $(function () {
//     // Make Masonry a jQuery plugin
//     jQueryBridget('masonry', Masonry, $);
    
//     $('.masonry > .wp-block-gallery').masonry({
//             itemSelector: '.wp-block-image',
//     });
        
//     setTimeout(function () {
//         window.dispatchEvent(new Event('resize'));
//     }, 150);
// });

$(function () {
    // Make Masonry a jQuery plugin
    jQueryBridget('masonry', Masonry, $);
    window.addEventListener('load', function () {
        $('.masonry > .wp-block-gallery').masonry({
            itemSelector: '.wp-block-image',
        });
    });
});



// Slick slider 
// $('.slider-slick-news').slick({
//     dots: false,
//     responsive: [
//       {
//         breakpoint: 4000,
//         settings: {
//           infinite: false,
//           speed: 300,
//           slidesToShow: 4,
//           slidesToScroll: 1,
//           autoplaySpeed: 2000,
//           dots: true,
//           arrows: false,
//         }
//       },
//       {
//         breakpoint: 1200,
//         settings: {
//           infinite: false,
//           speed: 300,
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           autoplaySpeed: 2000,
//           dots: true,
//           arrows: false,
//         }
//       },
//       {
//         breakpoint: 992,
//         settings: {
//           infinite: false,
//           speed: 300,
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           autoplaySpeed: 2000,
//           dots: true,
//           arrows: false,
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           infinite: false,
//           speed: 300,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           autoplaySpeed: 2000,
//           dots: true,
//           arrows: false,
//           variableWidth: true
//         }
//       },
//     ]
// });